import React, { useContext } from 'react';
import ModalLayout from 'components/ModalLayout';
import RestaurantFullInfoState from './restaurantFullInfoState/RestaurantFullInfoState';
import RestaurantFullInfoModal from './components/RestaurantFullInfoModal/RestaurantFullInfoModal';
import { IRestaurantsContext, RestaurantsContext } from '../Restaurants/restaurantsState/restaurantsContext';

const RestaurantFullInfoPage: React.FC = () => {
	const { fullInfoData, setFullInfoData } = useContext<IRestaurantsContext>(RestaurantsContext);

	const handleClose = () => {
		setFullInfoData('', undefined);
	};

	return (
		<RestaurantFullInfoState>
			<ModalLayout isVisible={!!fullInfoData.id} setIsShowModal={handleClose}>
				<RestaurantFullInfoModal />
			</ModalLayout>
		</RestaurantFullInfoState>
	);
};

export default RestaurantFullInfoPage;
